var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLocalMarketLogoOnly = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 12 12"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#FF7A14",
  clipPath: "url(#local-market-logo-only_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m6.96 3.045-.292 1.782L5.353 6.11l-1.77.266-1.74-.319-1.33-1.24L0 3.045l.604-1.72L1.842.033l1.74-.462 1.763.423L6.6 1.303z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.526 9.517h-2.32l-2.31.05-2.321-.048L2.5 7.197l.177-2.309-.003-2.223 2.223-.052 2.308-.066 2.385-.043-.184 2.384.069 2.31z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m11.922 5.653-2.241.014-2.31.017-2.32-.114.059 2.32-.087 2.308.045 2.304 2.15.126 2.131-.179 1.328-1.254 1.318-1.304-.127-2.154z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "local-market-logo-only_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0-.426h12v13.058H0z"
})))));
export default SvgLocalMarketLogoOnly;